import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";

import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import IconButton from "../../share/buttons/IconButton";
import moment from "jalali-moment";
import useFetch from "../../../Hooks/useFetch";
import { useCreate } from "../../../Context/CreateContext";

const TicketInfoCourse = ({ close, getTicket, edit, setEdit }) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [call, setCall] = useState("");

    const [ticket, setTicket] = useState({
        id: "",
        ticket_number: 0,
        ticket_name: "",
        ticket_price: "",
        ticket_start_time: "",
        ticket_end_time: "",
    });

    const handleModalClose = () => {
        close(false);
        setTicket({
            id: "",
            ticket_number: 0,
            ticket_name: "",
            ticket_price: "",
            ticket_start_time: "",
            ticket_end_time: "",
        });
        setStart("");
        setEnd("");
        setEdit("");
    };

    useEffect(() => {
        setTicket({
            ...ticket,
            ticket_start_time: moment(start, "HH:mm:ss jYYYY/jMM/jDD").format(),
        });
    }, [start]);
    useEffect(() => {
        setTicket({
            ...ticket,
            ticket_end_time: moment(end, "HH:mm:ss jYYYY/jMM/jDD").format(),
        });
    }, [end]);

    useEffect(() => {
        if (edit) {
            getTicketId.reFetch();
        }
    }, [edit]);

    useEffect(() => {
        if (edit) {
            setStart(
                moment(ticket.ticket_start_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );

            setEnd(
                moment(ticket.ticket_end_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        }
    }, [ticket]);

    const submitForm = () => {
        if (edit) {
            editTicket.reFetch();

            // if (!editTicket.loading) {
            //     setTicket({
            //         id: "",
            //         ticket_number: 0,
            //         ticket_name: "",
            //         ticket_price: "",
            //         ticket_start_time: "",
            //         ticket_end_time: "",
            //     });
            //     setStart("");
            //     setEnd("");
            //     console.log("reset");
            // }
            //TODO : pak kardane modal bad az patch

            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", 11);
            //TODO : id bootcamp dynamic she
            formData.append("ticket_name", ticket.ticket_name);
            formData.append("ticket_price", ticket.ticket_price);
            formData.append("ticket_number", ticket.ticket_number);
            formData.append("ticket_start_time", ticket.ticket_start_time);
            formData.append("ticket_end_time", ticket.ticket_end_time);

            setCall(formData);
            newTicket.reFetch();

            setTicket({
                id: "",
                ticket_number: 0,
                ticket_name: "",
                ticket_price: "",
                ticket_start_time: "",
                ticket_end_time: "",
            });

            setStart("");
            setEnd("");

            close();
        }
    };

    const newTicket = useFetch({
        method: "POST",
        url: `BootCampTicketService`,
        noHeader: false,
        trigger: false,
        data: call,
        caller: getTicket,
    });

    const getTicketId = useFetch({
        method: "GET",
        url: `BootCampTicketService/${edit}`,
        noHeader: false,
        setter: setTicket,
    });

    const editTicket = useFetch({
        method: "PATCH",
        url: `BootCampTicketService/${edit}`,
        noHeader: false,
        caller: getTicket,
        data: ticket,
    });

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={() => handleModalClose()}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-10">
                اطلاعات بلیت
            </h3>
            <form
                onSubmit={handleSubmit(submitForm)}
                className="flex flex-col justify-center"
            >
                <input
                    register={{
                        required: {
                            value: true,
                            message: "نام بلیت را وارد کنید",
                        },
                    }}
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام بلیت *"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[3rem] input"
                    value={ticket.ticket_name}
                    onChange={(e) =>
                        setTicket({
                            ...ticket,
                            ticket_name: e.target.value,
                        })
                    }
                />
                <div className="flex justify-around items-start gap-8 mb-[1.6rem]">
                    <input
                        register={{
                            required: {
                                value: true,
                                message: "قیمت بلیت را وارد کنید",
                            },
                        }}
                        type="number"
                        name="name"
                        control={control}
                        placeholder="قیمت بلیت *"
                        full={true}
                        className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] border-[1px] focus:outline-none"
                        value={ticket.ticket_price}
                        onChange={(e) =>
                            setTicket({
                                ...ticket,
                                ticket_price: parseInt(e.target.value),
                            })
                        }
                    />
                    <div className="flex items-start justify-center">
                        <IconButton
                            className="px-[1rem] py-[2.4rem] rounded-r-[1.5rem] bg-purple hover:bg-purple-dark"
                            text="اضافه کردن تعداد"
                            type="button"
                            onClick={() =>
                                setTicket({
                                    ...ticket,
                                    ticket_number: ticket.ticket_number + 1,
                                })
                            }
                        >
                            <AiOutlinePlus className=" text-[1.6rem] text-[#fff] " />
                        </IconButton>
                        <input
                            register={{
                                required: {
                                    value: true,
                                    message: "choose a number",
                                },
                            }}
                            type="number"
                            name="company_name"
                            control={control}
                            full={true}
                            className="border-[#21212182] h-[6.4rem] rounded-none  border-[1px] border-solid text-center bg-[#F2F3F5] text-[1.6rem] text-[#212121E5] placeholder:text-[#212121E5] focus:outline-none"
                            placeholder="تعداد بلیت"
                            value={
                                ticket.ticket_number === 0
                                    ? "تعداد بلیت"
                                    : ticket.ticket_number
                            }
                        />
                        <IconButton
                            className="px-[1rem] py-[2.4rem] rounded-l-[1.5rem] bg-black-prim opacity-[51%] hover:bg-black-prim hover:opacity-[71%]"
                            text="کم کردن تعداد"
                            type="button"
                            onClick={() =>
                                ticket.ticket_number > 0 &&
                                setTicket({
                                    ...ticket,
                                    ticket_number: ticket.ticket_number - 1,
                                })
                            }
                        >
                            <AiOutlineMinus className=" text-[1.6rem] text-[#fff] " />
                        </IconButton>
                    </div>
                </div>
                <div className="flex justify-around gap-8 mb-[1.6rem]">
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        setDate={setStart}
                        message="زمان شروع فروش بلیت را وارد کنید"
                        placeholder="زمان شروع فروش بلیت"
                        name="catch_end_date"
                        defaultValue={start}
                        control={control}
                        full={true}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        setDate={setEnd}
                        message="زمان پایان فروش بلیت را وارد کنید"
                        placeholder="زمان پایان فروش بلیت"
                        name="catch_end_date"
                        defaultValue={end}
                        control={control}
                        full={true}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                </div>
                <div className="flex gap-48 self-end">
                    <BtnPrimary
                        className=" py-[20px] px-[81px] mr-auto"
                        text="ثبت بلیت"
                    />
                </div>
            </form>
        </div>
    );
};

export default TicketInfoCourse;
